const props = {
  ALLOWED_FILE_TYPES: ['.pdf', '.jpg', '.jpeg', '.png', '.gif'],
  MAX_FILE_SIZE: 10000,
  MAYERS_ALLOWED_EXTEND_FILES: ['.pdf', '.jpg', '.jpeg', '.png', '.gif', '.docx', '.tiff', '.bmp'],
  OMA_ALLOWED_FILE_TYPES: ['.pdf', '.jpg', '.jpeg', '.png', '.gif', '.docx'],
};

export default props;
